import React from 'react';
import { formatDate } from 'helpers/date/formatDate';
import useStyle from './quiz.style';
import { IconLabel } from 'components/atoms/Texts/IconLabel';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { ClasseDate } from '../../types/classe/classe.def';

interface NoQuizzViewProps {
  classe: ClasseDate;
}

export const NoQuizzView = ({ classe }: NoQuizzViewProps) => {
  const classes = useStyle();

  const textDatesChallenge = () => {
    return classe?.debut && classe?.fin
      ? 'Du ' + formatDate(classe?.debut) + ' au ' + formatDate(classe?.fin)
      : 'Pas de challenge en cours';
  };

  return (
    <ContainerFullWidth>
      <FeatureContainer>
        <p className={classes.noQuizzHead}>
          Les quiz ne sont pas disponibles pour le moment, ils débuteront à
          partir du 06/10/2025.
        </p>
        <div className={classes.noQuizzContent}>
          <span>Date du challenge :</span>
          <IconLabel
            withoutMargin={true}
            icon="Calendar"
            label={textDatesChallenge()}
          />
        </div>
      </FeatureContainer>
    </ContainerFullWidth>
  );
};
